._ErrorMessage_gzpdp_1 {
  color: var(--color-red-600);
  margin-bottom: 16px;
}

._FieldWrapper_gzpdp_6 {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  width: 100%;
}

._FieldWrapper_gzpdp_6 label {
  display: block;
  font-weight: 500;
  width: 100%;
}

._FieldWrapper_gzpdp_6 input {
  box-sizing: border-box;
  width: 100%;
}

._FullWidthField_gzpdp_25 {
  box-sizing: border-box;
  display: block;
  width: 100%;
}

._FullWidthField_gzpdp_25 > div,
._FullWidthField_gzpdp_25 input {
  box-sizing: border-box;
  width: 100%;
}

/* Force full width on all Field inner elements */
._FieldWrapper_gzpdp_6 > div,
._FieldWrapper_gzpdp_6 .InputWrap,
._FieldWrapper_gzpdp_6 .Field,
._FieldWrapper_gzpdp_6 input {
  box-sizing: border-box;
  width: 100%;
} 